import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBW0zuuiR4R9o_yo90-l29gSx-MFVDQplQ",
  authDomain: "ui-grace.firebaseapp.com",
  projectId: "ui-grace",
  storageBucket: "ui-grace.firebasestorage.app",
  messagingSenderId: "464962438855",
  appId: "1:464962438855:web:c1b6b3d7276c80c33120e2"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
